import { Outlet, useParams } from 'react-router-dom';
import SkillsScopeProvider from '../SkillsScopeProvider';

/**
 * Organization mount wrapper: derives organizationId from the agent route and
 * provides SkillsScope to the shared skills pages via an Outlet layout route.
 */
const OrganizationSkillsScopeMount = () => {
    const { agentId } = useParams<{ agentId: string }>();
    const organizationId = agentId ?? '';

    return (
        <SkillsScopeProvider
            scope={{
                kind: 'organization',
                organizationId,
                basePath: `/agents/${organizationId}/skills`,
            }}
        >
            <Outlet />
        </SkillsScopeProvider>
    );
};

export default OrganizationSkillsScopeMount;
